module.exports = __webpack_public_path__ + "img/vin_image1.1d341f70.jpg";